module.exports = __webpack_public_path__ + "img/115.8.5959bcf6.png";